export const backdropStyles = {
  zIndex: 1,
  background: 'var(--transparentPrimary3)',
  backdropFilter: 'blur(4px)',
  margin: '0 auto',
  position: 'absolute'
}
